import { pause } from "./utils";
import type { Achat, Facture, LigneReception, Produit } from "./types";

export async function chargerPennylane(refresh = false): Promise<{
  factures: Facture[];
  achats: Achat[];
  ventesDu?: string;
  achatsDu?: string;
}> {
  const q = refresh ? "?refresh=1" : "";
  const [ventesRes, achatsRes] = await Promise.all([
    fetch(`/api/pennylane/ventes${q}`),
    fetch(`/api/pennylane/achats${q}`),
  ]);
  const ventes = (await ventesRes.json()) as {
    factures?: Facture[];
    du?: string;
    error?: string;
  };
  const achats = (await achatsRes.json()) as {
    achats?: Achat[];
    du?: string;
    error?: string;
  };
  if (!ventesRes.ok) throw new Error(ventes.error || "Ventes Pennylane indisponibles");
  if (!achatsRes.ok) throw new Error(achats.error || "Achats Pennylane indisponibles");
  return {
    factures: ventes.factures ?? [],
    achats: achats.achats ?? [],
    ventesDu: ventes.du,
    achatsDu: achats.du,
  };
}

export async function lireBonDeLivraison(_photo: string | null): Promise<LigneReception[]> {
  await pause(1600);
  return [
    { lu: "MOT 1.6 HDI 92CV", ref: "MOT-16HDI-92", qte: 2, conf: "sur" },
    { lu: "TURBO 1.5 DCI", ref: "TUR-15DCI", qte: 4, conf: "sur" },
    { lu: "KIT DISTRI 16 HDI", ref: "KIT-DIST-16HDI", qte: 10, conf: "verifier" },
    { lu: "ALTERNAT. 12V 180A", ref: "", qte: 3, conf: "inconnu" },
  ];
}

export async function lireEtiquette(ref: string, produits: Produit[]) {
  await pause(900);
  const p = produits.find((x) => x.ref === ref);
  return { ref, qte: p?.qte ?? 0 };
}
